export const FilterMap = {
  search: "storeName",
  district: "municipalLevelId",
  area: "districtLevelId"
}

export const FILTER_KEY = {
  SEARCH: "search",
  DISTRICT: "district",
  AREA: "area",
  SERVICES: "services"
}
